
<section class="wrap">
  <section class="header">
    <div class="user">
      <fa-icon [icon]="getFaIcon('faUserCircle')"></fa-icon>
      <span> {{user?.firstName}} {{user?.lastName}} </span>
    </div>
  </section>

  <section class="content">

    <form  [formGroup]="updatePersonalInfoForm" (ngSubmit)="onSubmit()">
     <div class="input_group">
        <mat-form-field appearance="outline">
          <mat-label>Prénom *</mat-label>
          <input matInput type="text" formControlName="firstName">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Nom *</mat-label>
          <input matInput type="text" formControlName="lastName">
        </mat-form-field>
     </div>

     <div class="input_group">
        <mat-form-field appearance="outline">
          <mat-label>N° téléphone</mat-label>
          <input matInput type="tel" formControlName="phone">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email">
        </mat-form-field>
     </div>

     <div class="input_group">
        <mat-form-field appearance="outline">
          <mat-label>Adresse</mat-label>
          <input matInput type="text" formControlName="address">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Ville</mat-label>
          <input matInput type="text" formControlName="city">
        </mat-form-field>
     </div>

     <div class="input_group">
        <mat-form-field appearance="outline">
          <mat-label>Code postal</mat-label>
          <input matInput type="text" formControlName="postalCode">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Pays</mat-label>
          <input matInput type="text" formControlName="country">
        </mat-form-field>
     </div>

      <button matInput type="submit" appChangeColorTheme attribute="bgc">Modifier mes informations</button>
    </form>

    <hr>

    <div class="redirections">
      <button type="button" appChangeColorTheme attribute="bgc" routerLink="/home/my-trainees">Mes stagiaires</button>
      <button type="button" form appChangeColorTheme attribute="bgc" routerLink="/home/purchases-history">Mes réservations</button>
    </div>

  </section>

</section>
